module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/sidebar/sidebar.component.scss
// module id = ./src/app/layout/sidebar/sidebar.component.scss
// module chunks = main